<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M54.91 56.74l-4.91-37A2 2 0 0048 18h-5v-2a11 11 0 00-22 0v2h-5.06a2 2 0 00-2 1.74l-4.87 37a2 2 0 002 2.26h41.86a2 2 0 002-2.26zM24 16a8 8 0 0116 0v2H24zM12.21 56l4.61-35H21v4.5a1.5 1.5 0 003 0V21h16v4.5a1.5 1.5 0 003 0V21h4.18l4.61 35z"/></svg>